import React from 'react';
import { Trans, t } from '@lingui/macro';
import StyledList from '~/app/pages/sales/invoicing/unpaid-invoices/shared-components/StyledList';
import ContactInformationGraphic from './images/contact-information-graphic.svg';

interface Props {
    children: string | JSX.Element;
}

export default function Introduction({ children }: Props) {
    return (
        <>
            <div className="mb-2">{children}</div>
            <div className="flex flex-row">
                <div className="mt-6 basis-3/5">
                    <h2 className="mb-6">
                        <Trans>Welcome to Rackbeat's Onboarding Process!</Trans>
                    </h2>
                    <div className="mb-6">
                        <Trans>
                            You are now adding e-conomic's warehouse solution, Lager by Rackbeat: A dedicated system for inventory
                            management that is fully integrated with your accounting in e-conomic.
                        </Trans>
                    </div>
                    <h5 className="mb-4">
                        <Trans>Here's What's Next:</Trans>
                    </h5>
                    <div className="rounded mb-6 bg-[#F6F6F6]">
                        <StyledList
                            elements={[
                                {
                                    text: t` In a few steps you will get redirected to Rackbeats own app where your onboarding will continue.`,
                                },
                                {
                                    text: t` Once you have completed the onboarding a Rackbeat Specialist will reach out to you to help you get a good start`,
                                },
                            ]}
                        />
                    </div>
                    <p className="mb-6">
                        <Trans>
                            Your products, suppliers, customers, payment terms and layout in e-conomic will automatically be
                            transferred to Lager by Rackbeat. It takes approx. 30 minutes and we will notify you by email when the
                            transfer is complete.
                        </Trans>
                    </p>
                    <p className="mb-4">
                        <Trans>If you have any questions, we are ready to help you. You can request to be contacted below.</Trans>
                    </p>
                </div>
                <div className="flex basis-2/5 justify-center items-center">
                    <img src={ContactInformationGraphic} className="h-64 w-64" />
                </div>
            </div>
        </>
    );
}
